module.exports = __webpack_public_path__ + "static/media/crash.46a7d0f3.wav";